import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { LandingPageComponent } from '@lib/components/landing-page/landing-page.component';
import { AuthService } from '@lib/services/auth-service.service';
import { authBackOfficeGuard, authContratGuard, authIsAdminGuard, authMigrationGuard, InitGuard } from 'src/app/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'contrats-stellium',
    loadComponent: () =>
      import('./app/components/contrats-stellium/contrats-stellium.component').then(mod => mod.ContratsStelliumComponent),
    canActivate: [authContratGuard],
  },
  {
    path: 'contrats-stellium/:id',
    loadComponent: () =>
      import('@lib/components/investisseur-details/tabs/contrats-stellium/contrat-stellium-detail/contrat-stellium-detail.component').then(
        mod => mod.ContratStelliumDetailComponent
      ),
    canActivate: [authContratGuard],
  },
  {
    path: 'migration-consultant',
    loadComponent: () =>
      import('./app/components/migration-consultant-dashboard/migration-consultant-dashboard.component').then(
        mod => mod.MigrationConsultantDashboardComponent
      ),
    canActivate: [authMigrationGuard],
  },
  {
    path: 'migration-consultant/:code',
    loadComponent: () =>
      import('./app/components/migration-consultant-detail/migration-consultant-detail.component').then(
        mod => mod.MigrationConsultantDetailComponent
      ),
    canActivate: [authMigrationGuard],
  },
  {
    path: 'wave-stats',
    loadComponent: () => import('./app/components/wave-dashboard/wave-dashboard.component').then(mod => mod.WaveDashboardComponent),
    canActivate: [authIsAdminGuard],
  },
  {
    path: 'financial-recalculation-dashboard',
    title: 'Suivi des recalculs financiers',
    loadComponent: () =>
      import('./app/components/financial-recalculation-dashboard/financial-recalculation-dashboard.component').then(
        mod => mod.FinancialRecalculationDashboardComponent
      ),
    canActivate: [authIsAdminGuard],
  },
  {
    path: 'investisseurs',
    loadComponent: () => import('./app/components/investisseurs/investisseurs.component').then(mod => mod.InvestisseursComponent),
    canActivate: [authBackOfficeGuard],
  },
  {
    path: 'fiche-conseil',
    loadComponent: () => import('./app/components/fiche-conseil/fiche-conseil.component').then(mod => mod.FicheConseilComponent),
    canActivate: [authBackOfficeGuard],
  },
  {
    path: 'investisseurs/from-list/:consultantCode/:investisseurCode',
    loadChildren: () =>
      import('@lib/components/investisseur-details/investisseur-details.routes').then(mod => mod.investisseurDetailsRoutes),
    canActivate: [authBackOfficeGuard],
  },
  {
    path: 'investisseurs/:consultantCode/:investisseurCode',
    loadChildren: () =>
      import('@lib/components/investisseur-details/investisseur-details.routes').then(mod => mod.investisseurDetailsRoutes),
    canActivate: [authBackOfficeGuard],
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('../../minotaure-lib/src/lib/components/error-pages/unauthorized/unauthorized.component').then(
        mod => mod.UnauthorizedComponent
      ),
  },
  { path: 'init', component: LandingPageComponent, canActivate: [InitGuard] },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: () => {
      const authService = inject(AuthService);
      // initialisation
      if (authService.isInitLogin()) {
        return '/init';
      }

      if (authService.isAdmin()) {
        return '/wave-stats';
      }
      //autorisé à voir les migrations
      if (authService.isMigrationViewer()) {
        return '/migration-consultant';
      }
      //autorisé à voir les contrats
      if (authService.isContratViewer()) {
        return '/contrats-stellium';
      }

      // connecté mais pas autorisé
      return '/unauthorized';
    },
  },

  // catch all
  {
    path: '**',
    redirectTo: '',
  },
];
